import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

export const relationContactSlice = createSlice({
    name: "relationContact",
    initialState: {
        ooid: null,
        relationContact: null,
        loading: false,
        error: null,
    },
    reducers: {
        setRelationContactOoid: (state, action) => {
            state.ooid = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRelationContact.fulfilled, (state, action) => {
            state.loading = false;
            state.relationContact = action.payload;
        });
        builder.addCase(fetchRelationContact.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchRelationContact.pending, (state) => {
            state.loading = true;
        });
    },
});

export const fetchRelationContact = createAsyncThunk('relationContact/fetch', async(_, { getState, rejectWithValue }) => {
    const { relationContact: { ooid } } = getState();
    if (!ooid) {
        return rejectWithValue('No ooid found');
    }
    try {
        const { response } = await Ows.handleRequest(
            'Otys.Services.RelationContactService.getDetail', [
                ooid,
                {
                    uid: true,
                    contactImage: true,
                    relationImage: true,
                    entryDateTime: true,
                    lastModified: true,
                    lastCommercialContact: true,
                    lastCpCommercialContact: true,
                    user: true,
                    userId: true,
                    lastModifiedBy: true,
                    contactNr: true,
                    directNr: true,
                    notes: true,
                    canBeMailed: true,
                    typeId: true,
                    isBilling: true,
                    isPassive: true,
                    isPrivate: true,
                    internalId: true,
                    enableSync: true,
                    enablePublishPersonalPage: true,
                    enableFoPublishing: true,
                    internalZipCode: true,
                    postBoxNr: true,
                    website: true,
                    jobTitle: true,
                    BulkMailSettings: true,
                    sendPrintAdvertising: true,
                    relation: true,
                    relationId: true,
                    education: true,
                    sendContactToAfas: true,
                    workAddressId: true,
                    cpId: true,
                    AddressWork: {
                        address: true,
                        city: true,
                        postcode: true,
                        countryCode: true,
                        country: true
                    },
                    Permissions: {
                        permissionTemplateId: true,
                        isKeyUser: true
                    },
                    Person: {
                        title: true,
                        initials: true,
                        firstName: true,
                        infix: true,
                        lastName: true,
                        suffix: true,
                        gender: true,
                        skype: true,
                        languageCode: true,
                        birthdate: true,
                        statusId: true,
                        statusName: true,
                        PhoneNumbers: {
                            type: true,
                            phoneNumber: true
                        },
                        photoFileName: true,
                        emailPrimary: true,
                        AddressPrimary: {
                            address: true,
                            city: true,
                            postcode: true,
                            countryCode: true
                        },
                        Emails: {
                            email: true,
                            isPrimary: true
                        }
                    },
                    OrganisationalUnit: {
                        organisationalUnitId: true
                    },
                    ConfigurableOrganisationUnits: {
                        unitId: true,
                        unitItemId: true
                    },
                    Profession: {
                        professionId: true
                    },
                    TimesheetsTerms: {
                        tscLastAcceptanceDate: true,
                        tscLastAcceptanceIp: true,
                        tscRequireAcceptance: true
                    },
                    Roles: {
                        uid: true,
                        name: true,
                        roleId: true
                    },
                    CongratulationEvents: {
                        uid: true,
                        name: true,
                        yearly: true,
                        description: true,
                        eventDate: true
                    },
                    SocialNetworks: {
                        socialNetwork: true,
                        socialNetworkId: true,
                        url: true,
                        description: true,
                        logoUrl: true
                    }
                }               
            ]
        );
        console.log('relationContact response', response);
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const { setRelationContactOoid } = relationContactSlice.actions;